import React, { useState } from "react";
import { api } from "../config/baseApi";

const PLACEHOLDER = "https://placehold.co/400x300/png?text=No+Image";

function ProductImage({ productId }: any) {
  const [imgSrc, setImgSrc] = useState(`${api}/product/photo/${productId}`);
  const [loading, setLoading] = useState(true);

  

  return (
    <div style={{ width: "100%", height: "160px", position: "relative" }}>
      {/* ✅ Loader */}
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f3f3f3",
            borderRadius: 12,
          }}
        >
          <span style={{ fontSize: 14, color: "#777" }}>Loading...</span>
        </div>
      )}

      <img
        src={imgSrc}
        alt="prodimg"
        style={{
          objectFit: "contain",
          height: "160px",
          width: "100%",
          borderRadius: 12,
          display: loading ? "none" : "block",
        }}
        onLoad={() => setLoading(false)}
        onError={(e) => {
          e.currentTarget.onerror = null;
          setImgSrc(PLACEHOLDER);
          setLoading(false);
        }}
      />
    </div>
  );
}

export default ProductImage;
